import React from "react";
import { useTranslation } from "react-i18next";
import Popup from "components/popup/Popup";

interface IApplyRolePermissionsPopupProps {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

export default function ApplyRolePermissionsPopup(props: IApplyRolePermissionsPopupProps) {
  const { t } = useTranslation();

  return (
    <Popup
      open={props.open}
      type="info"
      backDropCancel={false}
      title={t("Apply permissions to staff?")}
      description={t("Do you want to apply these new permissions to all staff members that have this role applied?")}
      okText={t("Yes")}
      cancelText={t("No")}
      onOk={props.onYes}
      onCancel={props.onNo}
    />
  );
}
